import React, { ComponentType, PropsWithChildren } from 'react';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { useTranslation } from 'react-i18next';
import { useOptimisedImages } from '@navi-toolbox/hooks';

type ProductImageProps = {
  src: string | null;
  alt: string;
  Container: ComponentType<PropsWithChildren>;
};

export const ProductImage = ({ Container, src, alt }: ProductImageProps) => {
  const { t } = useTranslation();
  const optimisedImage = useOptimisedImages({
    src,
    sizes: {
      thumb: {
        w: '240',
        h: '240',
      },
    },
  });

  return (
    <Container>
      <ImagePlaceholder
        src={optimisedImage.thumb?.x || ''}
        alt={alt}
        title={alt}
        loading="lazy"
        fallbackAlt={t('ui.image.alt')}
      />
    </Container>
  );
};
